
// H5登录-开启注册-白名单
export const H5_LOGIN_WHITE_LIST = new Set([
                          "200023915",
                          "200027687",
                          "200028062",
                          "200028909",
                          "200029004"]);

// client登录-关闭注册-白名单-默认开启
export const CLIENT_LOGIN_WHITE_LIST = new Set([
                          "200024951",
                          "200025297",
                          "200025295"]);

// client登录-开启自动登录-白名单
export const CLIENT_AUTOLOGIN_WHITE_LIST = new Set([
                          "200024245"]);

// 临时修改-模拟器开启注册-白名单
export const MONITOR_REGISTER_WHITE_LIST = new Set([
                          "200028999",
                          "200028643",
                          "200028644",
                          "200029002",
                          "200028645"]);

// client登录-关闭手机登录-白名单-默认开启
export const CLIENT_LOGIN_WHITE_ONLY_REG_LIST = new Set([
                          "200028505",
                          "200028506",
                          "200028507",
                          "200028508",
                          "200028999",
                          "200029000",
                          "200029001",
                          "200029002",
                          "200030088",
                          "200030089",
                          "200030090",
                          "200030091",
                          "200030092",
                          "200028509"]);

                          // 天穹支付参数                          
export const APPKEY_PARAMS = {
    // android-烈焰天地-200029834 tq9h6w2y8egwusxutu59 888066d8b7fe889eb8a09dd9cb3a0224
  "200029834": {
    "tq_app_id": "tq9h6w2y8egwusxutu59",
    "client_secret": "888066d8b7fe889eb8a09dd9cb3a0224",
    "tq_order_prefix": "lytd"
  },
  // android-神龙战士-200029835 tqqctrshpy2k930p3udy be5a00b94017687a8bb80b6998268c18
  "200029835": {
    "tq_app_id": "tqqctrshpy2k930p3udy",
    "client_secret": "be5a00b94017687a8bb80b6998268c18",
    "tq_order_prefix": "slzs"
  },
  // android-太古传奇-七绝-200030356 tqafx15oapv7rd4c9x2f 6ef63647c82206ec06ba77f445eca5ba
  "200030356": {
    "tq_app_id": "tqafx15oapv7rd4c9x2f",
    "client_secret": "6ef63647c82206ec06ba77f445eca5ba",
    "tq_order_prefix": "qj"
  },
  // android-太古传奇-倾国之怒-200030357 tq362ucy88loqvdk8qgj 1a79c7b26f7196f0017e88daa67af9f1
  "200030357": {
    "tq_app_id": "tq362ucy88loqvdk8qgj",
    "client_secret": "1a79c7b26f7196f0017e88daa67af9f1",
    "tq_order_prefix": "qgzn"
  },
};